import { render, staticRenderFns } from "./DetailsInformationManne.vue?vue&type=template&id=950ed340&"
import script from "./DetailsInformationManne.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationManne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports